import { Helmet } from "react-helmet";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import View from "../components/View";
import { APP_NAME } from "../constants";
import { useEffect, useState } from "react";
import * as api from "../api/proxies";
import toast from "react-hot-toast";
import { ProxyStats, Team } from "../types";
import { Card, Loader } from "@rigly/core";
import StratumProxiesList from "../components/proxies/StratumProxiesList";
import { useAuthContext } from "../context/AuthContext";

export default function Proxies() {
  const [loading, setLoading] = useState<boolean>(true);
  const [proxies, setProxies] = useState<ProxyStats[]>([]);
  const [total, setTotal] = useState<number>(0);

  const { team }: { team: Team | undefined } = useAuthContext();  

  const loadProxies = async () => {
    try {
      setLoading(true);
      const res = await api.getStratumProxies(team?.id);
      setProxies(res as unknown as ProxyStats[]);
      setTotal(res.count);
    } catch (ex: any) {
      console.log(ex.message);
      toast.error(ex.message, { position: "bottom-right" });
    }
    {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProxies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team]);

  useEffect(() => {
    const interval = setInterval(() => loadProxies(), 1000 * 60 * 10);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="flex flex-col">
      <Helmet>
        <title>{APP_NAME} - Proxies</title>
      </Helmet>
      <Topbar />
      <div className="flex min-h-screen-excluding-topbar">
        <View className="bg-radial-gradient-dark dark:bg-radial-gradient-light">
          <Sidebar />
          <div className="p-3">
            <Card className="pt-2 p-4 items-start bg-radial-gradient-dark dark:bg-radial-gradient-light before:relative space-y-3">
              {loading ? (
                <Loader />
              ) : (

                <StratumProxiesList
                  className=""
                  proxies={proxies}
                />
              )}
            </Card>
          </div>
        </View>
      </div>
    </div>
  )
}
